import React from "react";
import { Header } from "../header";
import { Section } from "../section";
import { Footer } from "../footer";
export var App = function () {
    return React.createElement("div", null,
        React.createElement(Header, null),
        React.createElement(Section, null),
        React.createElement(Footer, null));
};
